import { useEffect, useRef } from 'react'

export const placeCursorAtEnd = (el: HTMLElement) => {
  el.focus()
  const range = document.createRange()
  range.selectNodeContents(el)
  range.collapse(false)
  const sel = window.getSelection()
  sel?.removeAllRanges()
  sel?.addRange(range)
}

/**
 * Initialize the contentEditable with the current text.
 *
 * When `skipDefaultCaretPlacement` is true, the caller is responsible for
 * positioning the caret (e.g. from a click-derived hit-test). Otherwise the
 * caret is placed at end of text — the safe fallback for programmatic
 * edit-mode entry that doesn't carry a click position.
 */
export const useInnerTextSync = (
  text: string,
  skipDefaultCaretPlacement = false
) => {
  const editorRef = useRef<HTMLDivElement>(null)
  const initialTextRef = useRef(text)

  useEffect(() => {
    const el = editorRef.current
    if (!el) return
    el.innerText = initialTextRef.current
    if (!skipDefaultCaretPlacement) placeCursorAtEnd(el)
    // Mount-only: caller's `skipDefaultCaretPlacement` value at edit-mode
    // entry is what matters; later changes don't re-initialize the editor.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { editorRef, initialTextRef }
}
